import axios from 'axios';

let exApiUrl = window.i3.siteExApiURL;

const ossApi = axios.create({
  baseURL: exApiUrl+'i3-oss-api/',
  
  headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${process.env.REACT_APP_I3_OSS_API_TOKEN}` 
  }
});

export {
    ossApi,
};
